import React from "react";
import "./CarouselZeroState.scss";

const CarouselZeroState = ({ text, ...props }) => {
  return (
    <div className="CarouselZeroState">
      <div className="CarouselZeroStateTextContainer">
        <p>{text}</p>
      </div>
    </div>
  );
};

export default CarouselZeroState;
